import { render, staticRenderFns } from "./VaultSetupSameDeviceSync.vue?vue&type=template&id=608242ae&scoped=true"
import script from "./VaultSetupSameDeviceSync.vue?vue&type=script&lang=js"
export * from "./VaultSetupSameDeviceSync.vue?vue&type=script&lang=js"
import style0 from "./VaultSetup.scss?vue&type=style&index=0&id=608242ae&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608242ae",
  null
  
)

export default component.exports